export default "__VITE_ASSET__DWmkrcZA__"